var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-0 border",attrs:{"headers":_vm.headers,"items":_vm.medicamentos,"sort-desc":[false, true],"items-per-page":5,"multi-sort":""}})}
var staticRenderFns = []

export { render, staticRenderFns }